import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  getSignupReferralCode,
  setSignupReferralCode,
  clearSignupReferralCode,
  notifySignupReferralStorageChanged,
} from "@/lib/signupReferralStorage";

export default function SignUpReferralCode() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const existing = getSignupReferralCode();
    if (existing) setCode(existing);
  }, []);

  const handleContinue = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const raw = code.trim().toUpperCase();
    if (raw.length < 3) {
      setError("أدخل كوداً صالحاً (3 أحرف على الأقل)");
      return;
    }
    setSignupReferralCode(raw);
    notifySignupReferralStorageChanged();
    navigate("/signup", { replace: true });
  };

  const handleSkip = () => {
    clearSignupReferralCode();
    notifySignupReferralStorageChanged();
    navigate("/signup", { replace: true });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col" dir="rtl">
      <div className="flex items-center justify-between gap-3 px-4 pt-12 pb-5 shrink-0">
        <h1 className="text-xl font-bold text-foreground">كود الدعوة</h1>
        <button
          type="button"
          onClick={() => navigate("/signup", { replace: true })}
          className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center shrink-0 active:opacity-90 transition-opacity ring-2 ring-white/20 shadow-sm"
          aria-label="رجوع"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
        </button>
      </div>

      <div className="flex-1 flex flex-col px-6 pb-8 max-w-md mx-auto w-full min-h-0 overflow-y-auto">
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 rounded-2xl flex items-center justify-center bg-primary/12 shadow-inner">
            <Gift className="w-14 h-14 text-primary" strokeWidth={1.5} />
          </div>
        </div>

        <p className="text-center text-base font-bold text-foreground mb-1">
          وصل لك كود؟
        </p>
        <p className="text-center text-sm text-muted-foreground mb-8">
          أدخل كود الإحالة للاستفادة من الكاش باك
        </p>

        <form onSubmit={handleContinue} className="space-y-4 flex-1 flex flex-col">
          <div className="space-y-2">
            <Label htmlFor="signup-ref-code">ادخل الكود</Label>
            <Input
              id="signup-ref-code"
              dir="ltr"
              className="font-mono uppercase h-12 rounded-xl text-center text-base tracking-wide"
              placeholder="REFXXXXX"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              autoComplete="off"
              autoFocus
            />
            {error ? (
              <p className="text-xs text-destructive">{error}</p>
            ) : null}
          </div>

          <div className="flex-1 min-h-4" />

          <div className="flex flex-col gap-3 pt-2">
            <Button
              type="submit"
              className="w-full h-12 rounded-full text-base font-semibold"
            >
              متابعة
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-full h-12 rounded-full"
              onClick={handleSkip}
            >
              تخطي
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
